/* eslint-disable no-undef, camelcase */
// Derive webpack's runtime public path from the bundle's serving origin.
//
// This MUST run before any other module is evaluated. file-loader compiles each asset to
// `module.exports = __webpack_require__.p + "<hash>.<ext>"`, which captures the public path AT
// EVALUATION TIME into a frozen string. ES `import` hoisting evaluates sibling imports (fonts,
// images, svg) before the importing module's body — so the public path has to be set even earlier.
// Isolating it in its own module and importing it FIRST in the web-component entry guarantees it
// runs before those asset modules, so every static asset (and dynamic chunk) resolves to the bundle
// origin. Required for cross-origin embeds where the host page's origin differs from the bundle
// origin; for same-origin serving it is a no-op (assets would resolve relative to the document
// anyway). webpack 4 has no `output.publicPath: 'auto'`, so this manual assignment is the only
// runtime option.
//
// KEEP THIS AS THE FIRST IMPORT IN `index.web-component.js`. Reordering it after any asset-importing
// module reintroduces the cross-origin asset bug.
export const BUNDLE_ORIGIN = new URL('.', document.currentScript?.src || location.href).href;
__webpack_public_path__ = BUNDLE_ORIGIN;
/* eslint-enable no-undef, camelcase */